<template>
  <div type="card-full" v-loading="loading">
    <div class="pg-img" v-if="bgUrl.length>0 && showBackground">
      <img :src="uploadAddr + bgUrl[0].appendurl" alt="" class="img-c">
    </div>
    <div class="bid-notice-content" :class="{ 'no-bg': !showBackground }" id="px" ref="px">
      <div class="cjtzs-con">
        <div class="cjtzs-box">
            <p class="cjtzs-desc" v-html="psu.psubcncontent"></p>
            <div class="img-date">
              <div class="urlitem-box">
                <div class="urlitem" v-if="Osealurl.length>0">
                  <div class="img-i" >
                    <img :src="uploadAddr + Osealurl[0].appendurl" alt="" width="180" height="180" />
                  </div>
                  <div class="date-i">
                    <p>{{Osealurl[0].cosname?Osealurl[0].cosname:Osealurl[0].comfullname}}</p>
                    <p>{{psu.psuconfirmtime | ConverToDate}}</p>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
    <div style="height:30px"></div>
  </div>
</template>
<script>
  import {getLodop} from '@/assets/js/LodopFuncs'
import {mapGetters, mapState} from 'vuex'
  import utils from '../../assets/js/utils'
  import amount from '../common/amount'
  import request from '@/utils/request'
  // import config from '../../assets/config'
  let LODOP
  export default {
    name: 'pjBiddingFile',
    props:{
        psuid:Number,
        projectid:Number
    },
    filters: {
      newDate (value) {
        return utils.formatterDate(value, 'yyyy年MM月dd日')
      },
      qfwVal(value) {
        return utils.comdify(value)
      },
      ConverToDate(data) {
          let date = new Date(data)
          var chinese = ['O', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
          var y = date.getFullYear().toString();
          var m = date.getMonth()+1;
          m = m.toString()
          var d = date.getDate().toString();
          var result = "";
          for(let i = 0;i < String(y).length;i++){
            let z = y[i]
            result += chinese[z]
          }
          result += '年'
          if(m.length === 2){
            if (+m[0] === 1) {
                if(+m[1] === 0){
                    result += ("十月");
                } else {
                    result += ("十" + chinese[m.charAt(1)] + "月");
                }
                
            }
          } else {
            result += (chinese[m.charAt(0)] + "月");
          }
          if (d.length == 2 && +d.charAt(1) !== 0) {
            if (+d.charAt(0) === 1) {
              result += '十' + chinese[d.charAt(1)] + "日";
            } else {
              result += chinese[d.charAt(0)] + '十' + chinese[d.charAt(1)] + "日";
            }
          } else if (d.length == 2 && +d.charAt(1) == 0) {
            if (+d.charAt(0) === 1) {
              result += '十日'
            } else {
              result += chinese[d.charAt(0)] + '十' + "日";
            }
          } else {
              result += chinese[d.charAt(0)] + "日";
          }
          // if (d.length == 2 && +d.charAt(1) !== 0) {
          //     result += (chinese[d.charAt(0)] + "十" + chinese[d.charAt(1)] + "日");
          // } else if(d.length == 2 && +d.charAt(1) === 0){
          //     result += (chinese[d.charAt(0)] + "十" + "日");
          // } else {
          //     result += (chinese[d.charAt(0)] + "日");
          // }

          return result;
      },
    },
    data () {
      return {
        psu: {} ,
        btnLoading: false,
        Osealurl:[],
        bgUrl:[],
        loading:false
      }
    },
    async created () {
      await this.getPsu()
      await this.getComListbypid()
    },
    activated () {
      this.init()
    },
    // deactivated () {
    //   console.log(this.$data)
    //   Object.assign(this.$data, {})
    // },
    components: {amount},
    mounted () {
      // this.getPsu()
    },
    methods: {
      init(){
        // this.logoUrl = []
        this.bgUrl = []
      },
      async getPsu () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getpsubyid',
          params: {psuid: this.psuid}
        })
        if (res.length) {
          this.psu = res[0]
        }
        this.loading = false
      },
      async getComListbypid(){
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getComListbypid',
          params: {projectid: this.projectid, 
          cosid:this.$store.getters.loginUser.cosid}
        })
        this.Osealurl = res.filter(e => +e.appendtype === 4);
        if(+this.psu.prsflg === 2){
          this.bgUrl = res.filter(e => +e.appendtype === 9);
        }
        else {
          this.bgUrl = res.filter(e => +e.appendtype === 8);
        }
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      }
    },
    computed: {
      ...mapState({
        showBackground: state => state.app.showBackground
      }),
      uploadAddr () {
        return this.$store.getters.uploadAddr
      },
      prsflgName () {
        if (this.psu.prsflg == '1') {
          return '竞价'
        }
        else {
          return '开标'
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .pg-img{
    position: absolute;
    left: 54%;
    transform: translateX(-50%);
    width: 780px;
    height: 1127px;
    overflow: hidden;
    z-index: -9999;
    padding-right: 10px;
    .img-c{
        width: 100%;
    }
  }
  .bid-notice-content {
    margin: 10px auto;
    overflow: hidden;
    width: 798px;
    height: 1127px;
    // font-size: 14px;
    line-height: 35px;
    .cjtzs-con{
      width: 630px;
      // color: #626566;
      margin: 240px auto;
      b {
        color: #000;
      }
    }
    .no-bg .cjtzs-con {
      margin: 220px auto;
    }
    .cjtzs-box{
      position: relative;
    }
    .cjtzs-title{
    }
    .cjtzs-desc{
    }
    .t-indent{
      text-indent: 28px;
    }
    .t-underline{
      text-decoration: underline;
    }
    .t-color-b{
      color: #000;
    }
    .cjtzs-desc b {
      color: #000;
    }
    .img-date{
        position: relative;
    }
    .urlitem-box{
      position: absolute;
      top:42px;
      right: 20px;
    }
    .urlitem{
      float: left;
    }
    .img-i{
      position: absolute;
      top: -19px;
      // opacity: .5;
    }
    .date-i{
    }
  }

  @media print {
    body {
      margin: 0;
      padding: 0;
    }
    
    .bid-notice-content {
      // align-items: center !important;
      justify-content: center !important;
      display: flex !important;
      // font-size: 14px !important;
    }
    
    .cjtzs-con {
      width: 630px !important;
      // color: #626566 !important;
      // margin: 240px auto !important;
      margin-top: 220px !important;
      margin-right: 60px !important;

    }
    
    .cjtzs-box {
      position: relative !important;
    }
    
    .cjtzs-desc {
      text-align: left !important;
      margin: 0 !important;
      width: 100% !important;
    }
  }
</style>
